<template>
  <div>
    <v-dialog v-model="dialog" persistent scrollable width="500">

      <v-card :disabled="saveLoading" :loading="saveLoading">

        <v-card-title>
          {{ title }}
          <v-spacer/>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-10">

          <v-text-field v-model="form.name"
                        :error-messages="errors.name"
                        dense
                        label="Nom *"
                        outlined>
          </v-text-field>

          <v-textarea v-model="form.description"
                      :error-messages="errors.description"
                      dense
                      label="Description *"
                      outlined>
          </v-textarea>


        </v-card-text>

        <v-divider/>

        <v-card-actions class="grey lighten-4">
          <v-spacer/>
          <v-btn :loading="saveLoading"
                 color="secondary"
                 depressed
                 @click="save">
            <v-icon left>mdi-content-save</v-icon>
            Enregistrer
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
    data() {
        return {
            title: '',
            dialog: false,
            saveLoading: false,
            errors: {},
            form: {}
        }
    },
    methods: {
        open(item) {
            this.errors = {}
            this.dialog = true
            this.form = {
                id: item ? item.id : '',
                name: item ? item.name : '',
                description: item ? item.description : '',
            }
            this.title = item ? 'Modifier une base de données' : 'Ajouter une base de données'
        },
        save() {
            this.saveLoading = true
            this.errors = {}

            HTTP({
                url: this.form.id ? '/database/' + this.form.id + '/update' : '/database/store',
                method: this.form.id ? 'put' : 'post',
                data: this.form,
            }).then(() => {
                this.dialog = false
                this.$emit('refresh')
                this.$successMessage = 'Cet élément a ete enregistré avec succes'
                this.saveLoading = false
            }).catch(err => {
                this.saveLoading = false
                this.errors = err.response.data.errors
                console.log(err)
            })
        },
    },
}
</script>

<style scoped>

</style>